var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var create = Object.create,
      getPrototypeOf = Object.getPrototypeOf,
      plainObject = {};

  exports = function
    /* CustomCreate*/
  () {
    var setPrototypeOf = Object.setPrototypeOf,
        customCreate = arguments[0] || create;
    if (typeof setPrototypeOf !== "function") return false;
    return getPrototypeOf(setPrototypeOf(customCreate(null), plainObject)) === plainObject;
  };

  return exports;
}